import { ImgHTMLAttributes, PropsWithChildren } from "react";
import { Card, CardContent, CardHeader } from "./ui/containers/card";
import Typography from "./ui/typeography/typeography";

export function HelpHowToPage() {
  return (
    <div className="flex flex-col gap-2 lg:max-w-5xl">
      <ul className="list-disc list-inside space-y-2">
        <li>
          <Typography variant="span">
            Enter your starting point and destination to see available transit options in your area.
          </Typography>
        </li>
        <li>
          <Typography variant="span">
            Looking for a future trip? Use the&nbsp;
            <span className="font-semibold">“Plan”</span>
            &nbsp;tab to explore options for trips you may want to take later. Planning ahead is encouraged.
          </Typography>
        </li>
          <li>
          <Typography variant="span">
            Once you've found a trip that works for you, use the information provided to contact the recommended travel agency and schedule your ride.
          </Typography>
          </li>
      </ul>
      <Typography variant="p" affects="muted" className="mt-2 italic">
        <span className="font-semibold">Please note:</span> Trip times are estimates and may vary based on availability and demand, so be sure to confirm details when scheduling.
      </Typography>
 

      <Typography variant={"p"} affects={"muted"}>
        Information about trips is displayed in a couple of ways:
      </Typography>

      <MapLegend />
    </div>
  )
}

function MapLegend() {

  return (
    <div className="mt-1 flex flex-col gap-4">
      <MapLegendItem
        alt="Solid red arc visualizing flexible trips on the map."
        src="/assets/flex-route-single.png"
      >
        <Typography variant={"p"} affects={"small"} override={"removeMarginsAndLeading"}>
          Indicates that a demand-responsive service is available for your trip.
        </Typography>
      </MapLegendItem>
      <MapLegendItem
        alt="Checkered red and yellow arc visualizing trips that involve transfering agencies."
        src="/assets/flex-route-multiple.png"
      >
        <Typography variant={"p"} affects={"small"} override={"removeMarginsAndLeading"}>
          Indicates that your trip can be accomplished by coordinating a transfer between two demand-responsive services.
        </Typography>
      </MapLegendItem>
      <MapLegendItem
        alt="Dashed blue backround layer to show available service regions."
        src="/assets/layer-origin-accessible.png"
      >
        <Typography variant={"p"} affects={"small"} override={"removeMarginsAndLeading"}>
          Indicates the available service regions for the starting or end location selected.
        </Typography>
      </MapLegendItem>
    </div>
  )
}

function MapLegendItem({
  children,
  src = "/assets/placeholder.svg?url",
  alt = "Legend map placeholder image.",
}: PropsWithChildren<{
  src?: ImgHTMLAttributes<HTMLImageElement>["src"],
  alt?: ImgHTMLAttributes<HTMLImageElement>["alt"],
}>) {
  return (
    <Card className="grid grid-cols-[auto_1fr]">
      <CardHeader className="p-3">
        <img
          className="aspect-video h-full rounded-lg object-cover"
          height="124"
          width="124"
          src={src}
          alt={alt}
        />
      </CardHeader>

      <CardContent className="px-2 py-4 flex flex-col gap-1 justify-center">
        {children}
      </CardContent>
    </Card>
  )
}
